// extracted by mini-css-extract-plugin
export var orderSummary = "_ns-0";
export var showMoreLessButton = "_ns-1";